// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__MDp1U","loading__screen":"loading_loading__screen__50OHh"};